export default __webpack_public_path__ + "static/media/user.a70779f1.png";